//
// Shop: Categories show more
//

( function($, waTheme) {

    $(".js-categories-load").on("click", function () {
        $(this).parents(".b-categories").find(".b-categories__item-hidden").toggleClass("is-hidden")
    });

})(jQuery, window.waTheme);
